import React, { useContext } from 'react';
import LogoWhite from '../img/header/LogoWhite.png';
import LogoBlack from '../img/header/LogoBlack.png';
import MobileNav from './MobileNav';
import { Link } from 'react-router-dom';
import { CursorContext } from '../context/CursorContext';
import { useTheme } from '../context/ThemeContext';

const Header = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);

  const theme = useTheme();
  const darkMode = theme?.darkMode ?? true;
  const toggleTheme = theme?.toggleTheme;

  const textColor = darkMode ? 'text-white' : 'text-black';
  const hoverColor = 'hover:opacity-50';
  const borderColor = darkMode
    ? 'border-white/20 hover:border-white/60'
    : 'border-black/20 hover:border-black/60';

  return (
    <header
      className="w-full px-3 md:px-6 lg:px-10 z-30 h-[70px] lg:h-[100px] flex items-center"
      style={{
        backgroundColor: 'transparent',
        transition: 'all 0.3s ease',
      }}
    >
      <div
        onMouseEnter={mouseEnterHandler}
        onMouseLeave={mouseLeaveHandler}
        className="flex items-center justify-between w-full"
      >
        {/* LOGO */}
        <Link
  to="/"
  className={`max-w-[150px] lg:max-w-[230px] ${darkMode ? '-ml-9 lg:-ml-12' : '-ml-6 lg:-ml-9'}`}
>
  <img
    src={darkMode ? LogoWhite : LogoBlack}
    alt="logo"
    className="w-[150px] lg:w-[230px] h-auto"
  />
</Link>

        {/* DESKTOP NAV */}
        <nav className="hidden xl:flex items-center gap-x-12 font-semibold">
          <Link to="/about" className={`${textColor} ${hoverColor} transition`}>
            About
          </Link>
          <Link to="/portfolio" className={`${textColor} ${hoverColor} transition`}>
            Portfolio
          </Link>
          <Link to="/prints" className={`${textColor} ${hoverColor} transition`}>
            Prints
          </Link>
          <Link to="/blog" className={`${textColor} ${hoverColor} transition`}>
            Blog
          </Link>
          <Link to="/contact" className={`${textColor} ${hoverColor} transition`}>
            Contact
          </Link>

          {/* THEME TOGGLE */}
          <button
            onClick={toggleTheme}
            aria-label="Toggle theme"
            className={`w-8 h-8 flex items-center justify-center rounded-full border transition ${borderColor} ${textColor}`}
          >
            {darkMode ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.5}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364-6.364-.707.707M6.343 17.657l-.707.707M17.657 17.657l-.707-.707M6.343 6.343l-.707-.707M12 7a5 5 0 100 10A5 5 0 0012 7z"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.5}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 12.79A9 9 0 1111.21 3a7 7 0 009.79 9.79z"
                />
              </svg>
            )}
          </button>
        </nav>

        {/* MOBILE NAV */}
        <div className="xl:hidden">
          <MobileNav />
        </div>
      </div>
    </header>
  );
};

export default Header;